export const products=[
    {
        id:1,
        img: "https://images.pexels.com/photos/2957862/pexels-photo-2957862.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        link: "www.freecodecamp.com",
    },
    {
        id:2,
        img: "https://images.pexels.com/photos/3632689/pexels-photo-3632689.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        link: "https://www.udemy.com",
    },
    {
        id:3,
        img: "https://images.pexels.com/photos/3989831/pexels-photo-3989831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        link: "https://www.instagram.com",
    },
    {
        id:4,
        img: "https://images.pexels.com/photos/6844402/pexels-photo-6844402.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        link: "https://www.imagebazaar.com",
    },
    {
        id:5,
        img: "https://images.pexels.com/photos/8732964/pexels-photo-8732964.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        link: "https://pexels.com",
    },
    {
        id:6,
        img: "https://images.pexels.com/photos/7832679/pexels-photo-7832679.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        link: "https://www.twitter.com",
    }, 
]

export default products